/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
const ExpandIcon = ({ className = "" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className} test-id="OC6wy-kT">

      <path
        d="M6.58315 10L10.976 14.5L12.3427 13.075L9.34088 10L12.3427 6.925L10.976 5.5L6.58315 10ZM0.237907 10C0.237907 8.61667 0.49432 7.31667 1.00714 6.1C1.51932 4.88333 2.21469 3.825 3.09326 2.925C3.97184 2.025 5.00497 1.31267 6.19267 0.787999C7.38037 0.262666 8.64942 -4.97581e-07 9.99981 -4.37114e-07C11.3502 -3.76646e-07 12.6193 0.262666 13.807 0.788C14.9947 1.31267 16.0278 2.025 16.9064 2.925C17.7849 3.825 18.4806 4.88333 18.9935 6.1C19.5056 7.31667 19.7617 8.61667 19.7617 10C19.7617 11.3833 19.5056 12.6833 18.9935 13.9C18.4806 15.1167 17.7849 16.175 16.9064 17.075C16.0278 17.975 14.9947 18.6873 13.807 19.212C12.6193 19.7373 11.3502 20 9.99981 20C8.64942 20 7.38037 19.7373 6.19267 19.212C5.00497 18.6873 3.97183 17.975 3.09326 17.075C2.21469 16.175 1.51932 15.1167 1.00714 13.9C0.494319 12.6833 0.237907 11.3833 0.237907 10ZM2.19029 10C2.19029 12.2333 2.94684 14.125 4.45993 15.675C5.97303 17.225 7.81965 18 9.99981 18C12.18 18 14.0266 17.225 15.5397 15.675C17.0528 14.125 17.8093 12.2333 17.8093 10C17.8093 7.76667 17.0528 5.875 15.5397 4.325C14.0266 2.775 12.18 2 9.99981 2C7.81965 2 5.97303 2.775 4.45993 4.325C2.94684 5.875 2.19029 7.76667 2.19029 10Z"
        fill="#9A9A9A" test-id="fiBfyN5b" />

    </svg>);

};

export default ExpandIcon;